/* sp-flat: ersetzt im Vorschau-Theme sp-schwabing Produktbilder durch die flachen Photoroom-Draufsicht-Versionen.
   Map: window.SP_FLAT = { "<Original-Dateiname>": "<Flach-Dateiname>" } (aus snippets/sp-flat-map.liquid). */
(function () {
  var M = window.SP_FLAT || {};
  if (!Object.keys(M).length) return;
  var RE = /(\/(?:cdn\/shop|s\/files\/1\/0555\/9409\/0791)\/(?:files|products)\/)([^?\s,"']+?)(\.(?:jpe?g|png|webp))(\?[^\s,"']*)?/gi;
  function swapUrl(u) {
    if (!u || u.indexOf('/') < 0) return u;
    return u.replace(RE, function (all, pre, stem, ext, q) {
      var nf = M[stem + ext];
      if (!nf) return all;
      var base = pre.replace(/\/products\/$/, '/files/');
      var params = (q || '').replace(/^\?/, '').split('&').filter(function (p) { return p && p.indexOf('v=') !== 0; });
      return base + nf + (params.length ? '?' + params.join('&') : '');
    });
  }
  function fix(el) {
    ['src', 'srcset', 'data-src', 'data-srcset', 'data-zoom', 'data-zoom-src', 'href'].forEach(function (a) {
      var v = el.getAttribute && el.getAttribute(a);
      if (v && v.indexOf('/') >= 0) { var n = swapUrl(v); if (n !== v) el.setAttribute(a, n); }
    });
  }
  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('img,source,a[data-zoom],[data-zoom-src]')) fix(root);
    root.querySelectorAll('img,source,a[data-zoom],[data-zoom-src]').forEach(fix);
  }
  scan(document);
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.type === 'attributes') fix(m.target);
      else m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'] });
  window.SPFlatSwap = swapUrl;
})();
